import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React, {useCallback, useMemo} from 'react'
import {Dropdown} from 'wix-ui-tpa/cssVars'
import {usePageStateSelector} from '../../../../../hooks/state'
import {isRequestPending} from '../../../../../selectors/pending-requests'
import {classes} from './quantity.st.css'

interface QuantityProps {
  max: number
  value: number
  onSelectCount: (count: number) => void
}

export const Quantity = ({value, max, onSelectCount}: QuantityProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const reserveTicketsPending = usePageStateSelector(state => isRequestPending(state, 'RESERVE_TICKETS_REQUEST'))
  const fixEnabled = experiments.enabled(ExperimentNames.DonationInputFix)

  const _onSelectCount = useCallback(
    (count: number) => {
      if (reserveTicketsPending) {
        return
      }
      onSelectCount(count)
    },
    [onSelectCount],
  )

  const options = useMemo(
    () =>
      [...Array(max + 1).keys()].map(index => ({
        id: index.toString(),
        value: index.toString(),
        isSelectable: true,
      })),
    [max],
  )

  return (
    <Dropdown
      key={fixEnabled ? new Date().toISOString() : null}
      label={t('ticketsThankYou.quantity')}
      data-hook={DH.QUANTITY_PICKER}
      options={options}
      initialSelectedId={value.toString()}
      className={
        classes.quantity
      } /* don't add custom classes to Dropdown, eg. for positioning, since it affects popover Portal too */
      upgrade
      onChange={selectedOption => _onSelectCount(Number(selectedOption.id))}
      appendTo={(e: Element) => e.getAttribute('data-hook') === DH.eventDetails}
      mobileNativeSelect
    />
  )
}
